export const ACTION_CREATE_SITE__REQUEST = 'ACTION_CREATE_SITE__REQUEST';
export const ACTION_CREATE_SITE__SUCCESS = 'ACTION_CREATE_SITE__SUCCESS';
export const ACTION_CREATE_SITE__FAIL = 'ACTION_CREATE_SITE__FAIL';

export const ACTION_EDIT_SITE__REQUEST = 'ACTION_EDIT_SITE__REQUEST';
export const ACTION_EDIT_SITE__SUCCESS = 'ACTION_EDIT_SITE__SUCCESS';
export const ACTION_EDIT_SITE__FAIL = 'ACTION_EDIT_SITE__FAIL';

export const ACTION_LOAD_CREATE_PREPARATION__REQUEST = 'ACTION_LOAD_CREATE_PREPARATION__REQUEST';
export const ACTION_LOAD_CREATE_PREPARATION__SUCCESS = 'ACTION_LOAD_CREATE_PREPARATION__SUCCESS';
export const ACTION_LOAD_CREATE_PREPARATION__FAIL = 'ACTION_LOAD_CREATE_PREPARATION__FAIL';

export const ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS = 'ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS';
